export default {"src":"/_next/static/media/logo-circle.6a297e5c.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};